module.exports = __webpack_public_path__ + "static/media/control-vs-acceptance-large@2x.8eab989e.png";